import React, { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Divider, CircularProgress, Typography } from 'bonfire-kindling';

import { ToastContext } from 'contexts';
import { VENDORS_ME } from 'constants/apis';
import axios from 'helpers/axios';
import DashboardOverviewContentCard from './DashboardOverviewContentCard';

const Keywords = () => {
  const { t } = useTranslation();
  const { triggerToast } = useContext(ToastContext);
  const { isLoading, data: { data } = {} } = useQuery(
    ['vendors', 'me'],
    () => axios.get(VENDORS_ME),
    {
      onError: () => triggerToast({ message: t('generic_error') }),
    }
  );

  const { keywords } = data || {};

  return (
    <DashboardOverviewContentCard
      title={t('dashboard.overview.keywords.title')}
      count={keywords && `(${keywords.length})`}
      iconName="key"
      link={
        <IconButton
          component={RouterLink}
          to="/settings/keywords"
          iconName="pencil-alt"
          aria-label={t('dashboard.overview.keywords.edit')}
          variant="outline"
        />
      }
    >
      <Divider />
      {isLoading ? (
        <Box sx={{ m: 'auto', p: { xs: 3, lg: 0 } }}>
          <CircularProgress aria-label={t('components.loading_icon')} />
        </Box>
      ) : keywords?.length ? (
        <Box component="ul" sx={{ listStyleType: 'none', overflowY: 'auto', p: 0, m: 0 }}>
          {keywords.map(keyword => (
            <Box
              component="li"
              sx={{
                '&:not(:last-of-type)': {
                  borderBottom: theme => `1px solid ${theme.palette.divider}`,
                },
                p: 3,
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: '13px', wordBreak: 'break-word' }}>
                {keyword}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <Box sx={{ textAlign: 'center', m: 'auto', p: { xs: 3, lg: 0 } }}>
          <Typography component="p">{t('dashboard.overview.keywords.empty')}</Typography>
        </Box>
      )}
    </DashboardOverviewContentCard>
  );
};

export default Keywords;
